import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const PNNService = {
  getStadisticsPNN: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}pnn-portability/stats`);
  },
  getPNNforNumber: (phone_number: string) => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}pnn-portability/find/${phone_number}`);
  }
};
